export default "__VITE_ASSET__eHP6Id4o__"